var _style, _path, _g, _defs, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalStandardsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.1 141.9",
    style: {
      enableBackground: "new 0 0 108.1 141.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#11CCEA;stroke:#11CCEA;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#11CCEA;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st2{clip-path:url(#SVGID_00000037692605378254843340000002565990459143987604_);fill:#11CCEA;stroke:#11CCEA;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#11CCEA;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.6,10.4c-1.3,0-2.3,0-3.3,0c-3.3,0-6.6,0-9.9,0c-1.8,0-3-1-3-2.6s1.2-2.6,3-2.6c6.3,0,12.6,0,18.9,0 c2.2,0,3.1,0.9,3.1,3.2c0,6.3,0,12.5,0,18.8c0,2-1.2,3.2-2.9,3c-1.4-0.2-2.3-1.2-2.3-2.9c0-3.8,0-7.6,0-11.4c0-0.4,0-0.8,0-1.4 c-1.8,1.8-3.5,3.3-5.1,4.9C82,29.8,71.9,40.2,61.7,50.6c-1,1-1.9,2-2.9,3c-1.3,1.3-2.7,1.4-3.8,0.3c-1.2-1.1-1.1-2.6,0.1-3.9 c8.1-8.4,16.3-16.8,24.4-25.2c4.4-4.5,8.8-9.1,13.2-13.6C93,11.1,93.2,10.9,93.6,10.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.9,91.4l29.3-19l28.6,16.5l-11.5,39.8c0,0-8.7,7.3-17.6,7.1c-8.9-0.2-17.6-8.3-17.6-8.3L40.9,91.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "57.5,110.9 67.3,118.7 83.5,90.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "65,6.7 64.6,26.5 44.7,26.9 46,63.3 77,62.9 79.4,42.2 105.9,41.8 104.6,150.9 -11.9,149.2  1.3,17  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034056637335532592320000004912366943929053615_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000034056637335532592320000004912366943929053615_)",
      fill: "#11CCEA",
      stroke: "#11CCEA",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M35.6,20.1c0,0.7,0,1.3,0,1.9c0,6.6,0,13.2,0,19.8c0,2.5-1,3.5-3.5,3.5c-6.9,0-13.7,0-20.6,0c-0.4,0-0.7,0-1.3,0 c0,0.4,0,0.8,0,1.2c0,20.7,0,41.5,0,62.2c0,6.6,0,13.2,0,19.7c0,1.7,0.7,2.4,2.4,2.5c5.8,0,11.6,0,17.5,0c0.9,0,2,0.2,2.8,0.6 c1.1,0.5,1.5,1.9,1.1,3c-0.3,1.1-1.3,2-2.6,2c-1.6,0-3.2,0-4.8,0c-4.8,0-9.6,0-14.4,0c-4,0-7-2.6-7.6-6.4 c-0.1-0.4-0.1-0.9-0.1-1.3c0-15.3,0-30.5,0-45.8c0-13.3,0-26.6,0-39.8c0-1.2,0.4-2.2,1.2-3.1c5.4-5.3,10.7-10.7,16.1-16.1 c2.8-2.8,5.6-5.5,8.4-8.4c0.8-0.9,1.8-1.3,3-1.3c13.2,0,26.4,0,39.6,0.1c4.4,0,8.8,0,13.2,0c4.5,0,7.6,3.1,7.6,7.6 c0,10,0,20,0,30.1c0,3.4,0.1,6.8,0,10.1c0,2.4-2.4,3.6-4.3,2.4c-0.8-0.5-1.2-1.3-1.3-2.3c0-0.6,0-1.3,0-1.9c0-12.7,0-25.3,0-38 c0-1.9-0.6-2.5-2.5-2.5c-9.4,0-18.7,0-28.1,0c-7,0-14,0-21,0C36.3,20.1,36,20.1,35.6,20.1z M29.9,39.7c0-5.2,0-10.3,0-15.3 c-5.1,5.1-10.2,10.2-15.3,15.3C19.6,39.7,24.7,39.7,29.9,39.7z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 90.6,
    y1: 39.1,
    x2: 90.6,
    y2: 70.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 34,
    y1: 17.9,
    x2: 65.7,
    y2: 17.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalStandardsIcon);
export default __webpack_public_path__ + "static/media/external_standards_icon.7a59495af1e754991ed35f6479722222.svg";
export { ForwardRef as ReactComponent };